import { ACTION_TYPES, MUTATION_TYPES } from './types';

//Services or Api
import resourceService from './../resource.api';
import academicYearService from './../academicyear.api';

export const actions = {
  // 1) First Load all resources to server
  // 2) Getter resource key on demand
  async [ACTION_TYPES.GET_RESOURCES](context, payload) {
    //Model payload structure:
    /**
     * ['R3084644', 'R467494'] => Resources Keys
     *
     *  Only request the message that state don't have
     */

    if (Array.isArray(payload) && payload.length == 0) {
      payload = payload[0];
    }
    const requestResources = payload.filter((r) => {
      const notExist = Object.keys(context.state.resources).filter((p) => {
        return r == p;
      });
      return notExist.length == 0;
    });
    //Make Request with resources to add and saved
    if (requestResources.length != 0) {
      const resources = await resourceService.LoadValidationMessages(
        requestResources
      );
      context.commit(MUTATION_TYPES.SET_RESOURCES, resources);
      sessionStorage.setItem('resources', JSON.stringify(resources));
    }
  },
  async [ACTION_TYPES.GET_CURRENT_ACADEMIC_YEAR](context) {
    if (context.state.currentAcademicYear == null) {
      const academicYear = await academicYearService.getCurrentAcademicYear();
      context.commit(MUTATION_TYPES.SET_CURRENT_ACADEMIC_YEAR, academicYear);
      sessionStorage.setItem(
        'current-academic-year',
        JSON.stringify(academicYear)
      );
    }
  },
  async [ACTION_TYPES.GET_COMMON](context) {
    context.dispatch(ACTION_TYPES.GET_CURRENT_ACADEMIC_YEAR);
  },
};
